/**
 * Pure schedule-date validation (issue #176), extracted so it is testable
 * without mounting `CampaignSummaryTab` (Extract-Before-Mock, same
 * convention as `consequentialActions.ts`). Operates on the already-converted
 * ISO instant (`datetimeLocalValueToIso`'s output), never the raw
 * `datetime-local` string, so there is no ambiguity about timezone handling.
 */
export function validateScheduleDate(iso: string): string | null {
  if (!iso) {
    return "Ingresa una fecha para programar el envío.";
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "La fecha ingresada no es válida.";
  }
  if (date.getTime() <= Date.now()) {
    return "La fecha de programación debe ser posterior a este momento.";
  }
  return null;
}
